export const getLocalDateFromTimestamp = timestamp => {
  if (!timestamp) return null
  const date = new Date(timestamp)

  const day = date.getDate()
  const month = date.toLocaleString('default', { month: 'short' })
  const year = date.getFullYear()

  return `${day} ${month}, ${year}`
}

export const nth = function (d) {
  if (d > 3 && d < 21) return 'th'
  switch (d % 10) {
    case 1:
      return 'st'
    case 2:
      return 'nd'
    case 3:
      return 'rd'
    default:
      return 'th'
  }
}

export function getCurrentDate() {
  const date = new Date()
  const day = date.getDate()
  const month = date.toLocaleString('en-US', { month: 'long' })
  const year = date.getFullYear()
  // This arrangement can be altered based on how we want the date's format to appear.
  const currentDate = `${day}${nth(day)} ${month} ${year}`
  return currentDate
}

export const monthNameDateYear = createdAtString => {
  const date = new Date(createdAtString)
  const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' }
  const formattedDate = date.toLocaleDateString('en-US', options)
  return formattedDate
}
